import { GET_PRECIPITATION_MONTHLY_BY_LATLON } from '../actions/precipitationActions';
import { GET_PRECIPITATION_YEARLY_BY_LATLON } from '../actions/precipitationActions';
import { LOCATION_CHANGED } from '../actions/locationActions';

const initialState = {
    precipitationMonthlyIsRefreshing: false,
    precipitationYearlyIsRefreshing: false
};

export function precipitation(state = initialState, action)
{
    switch (action.type)
    {
        case LOCATION_CHANGED:
        {
            return initialState;
        }
        case GET_PRECIPITATION_MONTHLY_BY_LATLON.pending:
        {
            return {
                ...state
                , precipitationMonthly: undefined
                , precipitationMonthlyIsRefreshing: true
            };
        }

        case GET_PRECIPITATION_MONTHLY_BY_LATLON.fulfilled:
        {
            return {
                ...state
                , precipitationMonthly: action.payload
                , lastError: {}
                , precipitationMonthlyIsRefreshing: false
            };
        }

        case GET_PRECIPITATION_MONTHLY_BY_LATLON.rejected:
        {
            return {
                ...state
                , precipitationMonthly: undefined
                , lastError: action.payload
                , precipitationMonthlyIsRefreshing: false
            };
        }

        case GET_PRECIPITATION_YEARLY_BY_LATLON.pending:
        {
            return {
                ...state
                , precipitationYearly: undefined
                , precipitationYearlyIsRefreshing: true
            };
        }

        case GET_PRECIPITATION_YEARLY_BY_LATLON.fulfilled:
        {
            return {
                ...state
                , precipitationYearly: action.payload
                , lastError: {}
                , precipitationYearlyIsRefreshing: false
            };
        }

        case GET_PRECIPITATION_YEARLY_BY_LATLON.rejected:
        {
            return {
                ...state
                , precipitationYearly: undefined
                , lastError: action.payload
                , precipitationYearlyIsRefreshing: false
            };
        }

        default:
        {
            return state;
        }
    }
}
